module.exports = __webpack_public_path__ + "static/media/noimage.06ec898c.jpg";